import React, { useState } from "react";
import "./CompletionCard.scss";
import { Card, CardContent } from "@material-ui/core";
import { useSelector } from "react-redux";
import BadgesCertificatesDialogBox from "./BadgesCertificateDialogBox";

const ProgressBadge = (props: any) => {    
  const allInfo = useSelector((state: any) => state);
  const [openDialog, setOpenDialog] = useState(false);
  const [licenseType] = useState(allInfo.common.productID);
  const handleClose=()=> {
    setOpenDialog(false);
  }      
   let course = props?.skill;
   const getAppropriateBadge = () => {
    let appropriateBadge: string = "";

    if(course.perPartBadgePercentage >= 50 && course.perPartBadgePercentage <= 69){
        appropriateBadge = "Bronze";
        return appropriateBadge;
    }
    if(course.perPartBadgePercentage >= 70 && course.perPartBadgePercentage <= 79){        
        appropriateBadge = "Silver";
        return appropriateBadge;
    }
    if(course.perPartBadgePercentage >= 80 && course.perPartBadgePercentage <= 100){
        appropriateBadge = "Gold";
        return appropriateBadge;        
    }
   }


const getBadgeImage = () =>{      
    let appropriateBadge = getAppropriateBadge();
    let badgeUrl: string = "";
    let levelString: string = "";
    levelString = course.courseDetailObj[0].level.replace(".","-");

    if(licenseType === "21"){
        badgeUrl = process.env["REACT_APP_ASSETS_URL"] +
        "/halo/badges/solo-be/solo-be-" +
        appropriateBadge?.charAt(0) +
        "-" +
        levelString +
        "-" +
        "part-" +
        course.courseTitle + 
        ".svg";    
    }
    else if(licenseType === "22"){
        badgeUrl = process.env["REACT_APP_ASSETS_URL"] +
        "/halo/badges/solo-bg/solo-bg-" +
        appropriateBadge?.charAt(0) +
        "-" +
        levelString +
        "-" +
        "part-" +
        course.courseTitle + 
        ".svg";    
    }
    else if(licenseType === "23"){
        badgeUrl = process.env["REACT_APP_ASSETS_URL"] +
        "/halo/badges/solo-bf/solo-bf-" +
        appropriateBadge?.charAt(0) +
        "-" +
        levelString +
        "-" +
        "part-" +
        course.courseTitle + 
        ".svg";    
    }else if(licenseType === "24"){
        badgeUrl = process.env["REACT_APP_ASSETS_URL"] +
        "/halo/badges/solo-bs/solo-bs-" +
        appropriateBadge?.charAt(0) +
        "-" +
        levelString +
        "-" +
        "part-" +
        course.courseTitle + 
        ".svg";    
    } else if(licenseType === "26" ){
      badgeUrl = process.env["REACT_APP_ASSETS_URL"] +
      "/halo/badges/business-german/sprint-bg-" +
      appropriateBadge?.charAt(0) +
      "-" +
      levelString +
      "-" +
      "part-" +
      course.courseTitle + 
      ".svg";    
    } else if(licenseType === "20" ){
      badgeUrl = process.env["REACT_APP_ASSETS_URL"] +
      "/halo/badges/business-english/sprint-be-" +
      appropriateBadge?.charAt(0) +
      "-" +
      levelString +
      "-" +
      "part-" +
      course.courseTitle + 
      ".svg";    
    } else if(licenseType === "27" ){
      badgeUrl = process.env["REACT_APP_ASSETS_URL"] +
      "/halo/badges/business-french/sprint-bf-" +
      appropriateBadge?.charAt(0) +
      "-" +
      levelString +
      "-" +
      "part-" +
      course.courseTitle + 
      ".svg";    
    } else if(licenseType === "28" ){
      badgeUrl = process.env["REACT_APP_ASSETS_URL"] +
      "/halo/badges/business-spanish/sprint-bs-" +
      appropriateBadge?.charAt(0) +
      "-" +
      levelString +
      "-" +
      "part-" +
      course.courseTitle + 
      ".svg";    
    }
    
    return badgeUrl.toLowerCase();
}

  return (
    <React.Fragment>
       <div className="badge-container">
            <Card className="completion-card no-shadow general-clickable" onClick={()=> setOpenDialog(true)}>
                <CardContent className="completion-card-body">                         
                    <div>
                        {!course.badgeAvailability && (
                        <img alt="badge-placeholder" src={"../../../images/badge/badge-placeholder.svg"} className={"badge-placeholder"} />
                        )}                        
                        {course.badgeAvailability && (
                        <img alt="overall-badge"  src={getBadgeImage()} className={"overall-badge"} />
                        )}                                    
                        {!course.badgeAvailability && (
                       <button className="remove-button-default-style" onClick={() => setOpenDialog(true)}>
                       <img alt="cert-badge-lock" src="../../../images/cert-badge-lock.svg" className="lock-icon" />
                       </button>
                        )}                    
                    </div>              
                </CardContent>
            </Card>
       </div>
       {openDialog && course.dialogContentLocal && 
       <BadgesCertificatesDialogBox
        onKeyDown={() => {}}
        openDialog={openDialog}
        dialogContent={course.dialogContentLocal}
        handleClose={handleClose}
        skill={props?.skill}
      />}
    </React.Fragment>
  );
};

export default ProgressBadge;
